import ArticlesBlock from './ArticlesBlock.client'

export const SEARCH_PARAM_FOR_CATEGORY = 'group'

export default ArticlesBlock
